export default locale =>
  ({
    es: 'es-es',
    en: 'en-en',
    ar: 'ar-ae',
    ca: 'es-ca',
    pl: 'pl-pl',
    pt: 'pt-pt',
  }[locale]);
